import { Panel } from '@/ui/atoms/panel/Panel'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PageLayout } from '@/ui/layouts/PageLayout'

export function SpkGovernanceSkeleton() {
  return (
    <PageLayout>
      <Skeleton className="h-[60px] w-[240px]" />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-4">
          <Panel className="flex h-[202px] flex-col gap-10 md:h-[278px]">
            <Skeleton className="h-6 w-[160px]" />
            <Skeleton className="h-8" />
            <Skeleton className="h-8" />
          </Panel>
          <Panel className="flex h-[197px] flex-col gap-8 md:h-[205px]">
            <Skeleton className="mt-10 h-6 w-[160px]" />
            <Skeleton className="h-8 md:hidden" />
            <Skeleton className="h-8" />
          </Panel>
        </div>
        <Panel variant="secondary" className="flex h-[345px] flex-col items-center gap-8 md:h-[361px]">
          <Skeleton className="m-10 h-9 w-[160px] bg-primary/10" />
          <Skeleton className="h-6 w-full bg-primary/10" />
          <Skeleton className="h-6 w-full bg-primary/10" />
          <Skeleton className="h-6 w-full bg-primary/10" />
        </Panel>
      </div>
    </PageLayout>
  )
}
